import { Add } from "@mui/icons-material";
import { Box, Button, Grid2 as Grid, Typography } from "@mui/material";
import { FC, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { addressTitles } from "src/shared/constants/address.constants";
import { IAddressFull, TAddressType } from "src/shared/types/address.types";
import { IPartnerDto } from "src/shared/types/partner.types";
import { Operation } from "../partnerForm/Operation";
import { AddAddressModal } from "./AddAddressModal";
import { AddressItem } from "./AddressItem";

interface IAddressesProps {
  partner: IPartnerDto;
  addresses: IAddressFull[];
  registrationCountryId: number;
}

export const Addresses: FC<IAddressesProps> = ({
  partner,
  addresses,
  registrationCountryId,
}) => {
  const [addAddressType, setAddressType] = useState<TAddressType | null>(null);
  const { partner_id } = useParams();
  const { hasPostalAddress, hasAdditionalAddress, hasLegalAddress } =
    useMemo(() => {
      return {
        hasPostalAddress: !!addresses.find(
          (address) => address.type.value === "postal",
        ),
        hasLegalAddress: !!addresses.find(
          (address) => address.type.value === "legal",
        ),
        hasAdditionalAddress: !!addresses.find(
          (address) => address.type.value === "postal_additional",
        ),
      };
    }, [addresses]);

  return (
    <Grid container spacing={4}>
      {addresses.map((address) => {
        let order = 3;
        switch (address.type.value) {
          case "legal": {
            order = 1;
            break;
          }
          case "postal": {
            order = 2;
            break;
          }
        }

        return (
          <Grid
            key={address.id}
            size={12}
            sx={{
              order: order,
            }}
          >
            <AddressItem
              address={address}
              registrationCountryId={registrationCountryId}
            />
          </Grid>
        );
      })}
      {!hasLegalAddress && (
        <Grid
          size={12}
          sx={{
            order: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>{addressTitles.legal}</Typography>
            <Button
              onClick={() => setAddressType("legal")}
              variant="outlined"
              endIcon={<Add />}
            >
              Добавить
            </Button>
          </Box>
        </Grid>
      )}
      {!hasPostalAddress && (
        <Grid
          size={12}
          sx={{
            order: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>{addressTitles.postal}</Typography>
            <Button
              onClick={() => setAddressType("postal")}
              variant="outlined"
              endIcon={<Add />}
            >
              Добавить
            </Button>
          </Box>
        </Grid>
      )}
      {!hasAdditionalAddress && (
        <Grid
          size={12}
          sx={{
            order: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>{addressTitles.postal_additional}</Typography>
            <Button
              onClick={() => setAddressType("postal_additional")}
              variant="outlined"
              endIcon={<Add />}
            >
              Добавить
            </Button>
          </Box>
        </Grid>
      )}
      <>
        {addAddressType && partner_id && (
          <AddAddressModal
            type={addAddressType}
            registrationCountryId={registrationCountryId}
            open
            partnerId={partner_id}
            onClose={() => setAddressType(null)}
          />
        )}
      </>
      <Grid size={12} sx={{ order: 9999 }}>
        <Operation partner={partner} />
      </Grid>
    </Grid>
  );
};
